import React from "react";
import useToggle from "../../../hooks/useToggle";
import GoToTop from "../../Helpers/GoToTop";
import FollowModal from "../../Helpers/Modals/FollowModal";
import Drawer from "../../Mobile/Drawer";
import FooterOne from "../../Partials/Footers/FooterOne";
import HeaderOne from "../../Partials/Headers/HeaderOne";
import MainContent from "../PlaceABidCom/MainContent";

function PlaceBidTwo() {
  const [drawer, setDrawer] = useToggle(false);
  const [value, setValue] = useToggle(true);
  return (
    <>
      <Drawer drawer={drawer} action={setDrawer.toggle} />
      <HeaderOne className="shop-page-header" action={setDrawer.toggle} />
      <MainContent modalAction={setValue.toggle}>
        <FollowModal
          action={setValue.toggle}
          value={value}
          className="place-bid2"
        />
      </MainContent>
      <FooterOne />
      <GoToTop />
    </>
  );
}

export default PlaceBidTwo;
